window.addEventListener("load", function(event) {

    $('[name=measure-unit]').on('change', function() {
        measureUnits($(this).val());
    });


    initDogsPopulation();
    measureUnits();

    function initDogsPopulation() {

        if ($('[data-id=dogs-collection]')[0]) {

            var dogs = Array.isArray(window.DOGS) ? window.DOGS : [];

            if (!dogs.length) {
                console.warn('[dogsparser] window.DOGS is empty — check that the dog_breed metaobject type exists and snippets/dogs-data is rendered.');
            }

            for (var i = 0; i < dogs.length; i++) {
                (function (dog) {
                    $('[data-id=dogs-collection]').each(function () {
                        var $option = $('<span class="dog-race-option"></span>')
                            .attr('data-size-harness-lang', dog.sizeHarnessLang)
                            .attr('data-size-harness', dog.sizeHarness)
                            .attr('data-size-lang', dog.sizeLang)
                            .attr('data-size', dog.size)
                            .attr('data-title', dog.name)
                            .text(dog.name);
                        $(this).append($option);
                    });
                })(dogs[i]);
            }

            addDogsFieldEvents();

        }

        if($('.swatch').length) {

            var checkedSwatch = $('.swatch input:checked');
            var checkedSwatchId = checkedSwatch[0].id;

          
            var optionValue = checkedSwatch.val();
            $('.swatch-size-info').hide();
            var targetInfoBlock = $(".swatch-size-info[data-size-option='" + optionValue.charAt(0).toLowerCase() + "']")
            targetInfoBlock.show();


            // overall variables
            let attributActiveSwatch = $('.swatch-element.active').attr('data-size-option'); //get data-option value for active swatch
            let firstChild = $('.swatch-size-info').first();
            let attributFirstChild = firstChild.attr('data-size-option');  //get data-option value for first child 

            //cats variables
            let activeSwatch = $('.swatch-element').hasClass("active");
            let uniqueSwatch = $('.swatch-element').hasClass("unique");

            if (attributFirstChild == attributActiveSwatch  ) {
                firstChild.show();
            } 
            // cats logic
            if(uniqueSwatch && activeSwatch) {
                firstChild.show();
            }
            
            
          
        
            if (optionValue) {
                if (checkedSwatchId == 'swatch-0-tres-petit' || checkedSwatchId == 'swatch-0-extra-small') {
                    $('.swatch-size-info[data-size-option="tp"]').show();
                } else if (checkedSwatchId == 'swatch-0-petit' || checkedSwatchId == 'swatch-0-small') {
                    $('.swatch-size-info[data-size-option="p"]').show();
                }
            }
        }

        $('.product-form__overlay').hide();

    }

    function measureUnits(unit) {

        if (unit == null) {
            unit = 'in';
            $('#measure-unit-in').prop( "checked", true );
        }

        $.getJSON("//tellaandstella.com/cdn/shop/t/166/assets/measurements.json?v=53236320203263140271777138798", function(result){
            $('[data-size-value]').each(function() {
                var unitValue = $(this).attr("data-size-value");
                if (result[unitValue][unit]) {
                    $(this).text(result[unitValue][unit]);
                }
            });
        });

    }

    function selectProductOption(regularSize, harnessSize, race) {
        $('.swatch-size-info').hide();
        $('.recommanded-for').hide();

        var size = regularSize;

        var harnessSignals = [
            window.DOGS_PRODUCT_TYPE,
            window.DOGS_PRODUCT_TEMPLATE,
            (theme && theme.productStrings && theme.productStrings.productType)
        ].map(function (s) { return (s || '').toLowerCase(); }).join(' ');

        if (harnessSignals.indexOf('harnais') !== -1 || harnessSignals.indexOf('harness') !== -1) {
            size = harnessSize;
        }

        var targetInfoBlock = $('.swatch-size-info[data-size-option=' + size + ']');

        targetInfoBlock.show();
        targetInfoBlock.find('[data-id=dog-race]').text(race);
        targetInfoBlock.find('.recommanded-for').show();

        // Check if the target variant is out of stock
        var isOutOfStock = $('[data-id=product-swatch-size][data-size-option=' + size + '].soldout').length;


        // Check if on product page with swatches
        if($('[data-id=product-swatch-size]').length) {
            // Check if variant exists AND is in stock
            if ($('[data-id=product-swatch-size][data-size-option=' + size + ']').length) {
                if(isOutOfStock == false){
                    $('.no-size-stock-notice').removeClass('active');
                    $('.no-size-notice').removeClass('active');
                } else {
                    $('.no-size-notice').removeClass('active');
                    $('.no-size-stock-notice').addClass('active');
                }
                if($('[data-pre-select=false]').length > 0) return
                $('[data-id=product-swatch-size][data-size-option=' + size + '] label').click();

            } else {
                $('.no-size-notice').addClass('active');
                $('.no-size-stock-notice').removeClass('active');
            }
            if ($('[data-id=product-swatch-size][data-size-option="unique"]').length) {
                $('.swatch-size-info').show();
            }
        }
    }


    function addDogsFieldEvents() {

        var dogCookie = getCookie('dograce');
        var dogSize = getCookie('dogsize');

        $(".dropbtn").on('click', function () {
            $("[data-id='dogs-collection']").toggleClass("show");
        });

        $(".dropbtn-modal").on('click', function ($e) {
            document.getElementById("race-de-ton-chien-dropdown-modal").classList.toggle("show");
        });

        $(".search-dropdown").on('keyup', function ($e) {
            var input, filter, ul, li, a, i, span;
            input = document.getElementById("race-de-ton-chien");
            filter = input.value.toUpperCase();
            div = document.getElementById("race-de-ton-chien-dropdown");
            a = div.getElementsByTagName("span");
            for (i = 0; i < a.length; i++) {
                txtValue = a[i].textContent || a[i].innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    a[i].style.display = "";
                } else {
                    a[i].style.display = "none";
                }
            }
        });

        $(".search-dropdown-modal").on('keyup', function ($e) {
            var input, filter, ul, li, a, i, span;
            input = document.getElementById("race-de-ton-chien-modal");
            filter = input.value.toUpperCase();
            div = document.getElementById("race-de-ton-chien-dropdown-modal");
            a = div.getElementsByTagName("span");
            for (i = 0; i < a.length; i++) {
                txtValue = a[i].textContent || a[i].innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    a[i].style.display = "";
                } else {
                    a[i].style.display = "none";
                }
            }
        });

        $('.close-size-search').on('click', function() {
            unsetDog();
        });

        $(".dog-race-option").on('click', function() {

            $('.feature-row__item[data-size]').removeClass('active multiple-sizes');
            $('.multiple-sizes-notice').removeClass('active');
            $('.no-size-notice').removeClass('active');

            var sizeValue = $(this).attr('data-size');
            var sizeValueLang = $(this).attr('data-size-lang');
            let is_modal = false;

            var sizeHarnessValue = $(this).attr('data-size-harness');
            var sizeHarnessValueLang = $(this).attr('data-size-harness-lang');


            var breedTitle = $(this).attr('data-title');
            var optionValue = $(this).text();
            var inputField = $(this).closest(".dropdown-content").find(".search-dropdown");

            if (this.parentElement.id === 'race-de-ton-chien-dropdown-modal') {
                is_modal = true;
            }

            updateKlaviyoBreed(breedTitle);

            setCookie('dograce', optionValue, 365);
            setCookie('dogsize', sizeValue, 365);
            setCookie('dogsizeharness', sizeHarnessValue, 365);

            inputField.val(optionValue);

            if (!is_modal) {
                $(this).closest(".dropdown").find(".dropbtn").text(optionValue);
                document.getElementById("race-de-ton-chien-dropdown").classList.toggle("show");
            } else {
                $(this).closest(".dropdown").find(".dropbtn-modal").text(optionValue);
                document.getElementById("race-de-ton-chien-dropdown-modal").classList.toggle("show");
            }

            var multipleSizes = false;

            if (sizeValue.includes('-')) {
                multipleSizes = true;
            }

            if($('.mobile-dog-race').length) {
                $('.mobile-dog-race').html('- ' + optionValue);
            }

            if (sizeValue.includes('ND') && sizeValue.length == 2) {
                $('.no-size-notice').addClass('active');
            }

            if (multipleSizes) {

                if (sizeValue.includes('ND') && sizeValue.length == 2) {
                    $('.no-size-notice').addClass('active');
                }

                else {

                    $('.multiple-sizes-notice').addClass('active');
                    for (var i = 0; i < sizeValue.length; i++) {
                        var sizeSingle = sizeValue.charAt(i);
                        $('.feature-row__utility-item[data-size=' + sizeSingle + ']').find('[data-id=dog-race]').text(optionValue);
                        $('.feature-row__utility-item[data-size=' + sizeSingle + ']').addClass('active multiple-sizes');
                    }
                }
            }
            else {
                var targetUtilityItem = $('#size-guides-mobile .feature-row__utility-item[data-size=' + sizeValue + ']');
                var targetUtilityItemHarness = $('#size-guides-mobile .feature-row__utility-item--harness[data-size=' + sizeHarnessValue + ']');
                var targetScroll = $('#size-guides-mobile');
                var targetOffset = 100;

                targetUtilityItem.find('[data-id=dog-race]').text(optionValue);
                targetUtilityItem.addClass('active');

                targetUtilityItemHarness.find('[data-id=dog-race]').text(optionValue);
                targetUtilityItemHarness.addClass('active');

                if(targetUtilityItem.length) {
                    if (!targetScroll.hasClass('size-modal')) {
                        $('html, body').animate({
                            scrollTop: targetScroll.offset().top - targetOffset
                        }, 1000);
                    }

                }

            }

            selectProductOption(sizeValueLang, sizeHarnessValueLang, optionValue);

        });

        if (dogCookie) {
            $('.dog-race-option[data-title="' + dogCookie + '"]').click();
            $("#race-de-ton-chien-dropdown").removeClass("show");
            $("#race-de-ton-chien-dropdown-modal").removeClass("show");
        }

    }

    function unsetDog() {
        $('#race-de-ton-chien').val('');
        $('#race-de-ton-chien-dropdown').removeClass("show");
        $('#race-de-ton-chien-dropdown-modal').removeClass("show");
        $('.recommanded-for').hide();
        $('.mobile-dog-race').html('');
        $('.multiple-sizes-notice').removeClass('active');
        $('.no-size-notice').removeClass('active');
        $('.dropbtn').html("Sélectionner une race");
        $('.dropbtn-modal').html("Sélectionner une race");
        document.cookie = "dogsize=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "dograce=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        const dropdowns = document.querySelectorAll('#race-de-ton-chien-dropdown span, #race-de-ton-chien-dropdown-modal span');
        dropdowns.forEach( element => element.style.display = "")
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

});